/* CORO · JS mínimo (vanilla, defer). Compatible con el editor de Shopify. */
(function () {
  document.documentElement.classList.add('js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Números que cuentan (siempre animan: es un efecto corto de una sola vez) */
  function countUp(scope) {
    scope.querySelectorAll('[data-countup]:not([data-cu-done])').forEach(function (el) {
      el.setAttribute('data-cu-done', '');
      var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
      var t0 = null;
      el.textContent = '0';
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / 1100, 1);
        p = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * p);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  /* Reveal on scroll */
  function initReveal(root) {
    var items = root.querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); countUp(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          countUp(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Countdown de ofertas */
  function initCountdown(root) {
    root.querySelectorAll('[data-countdown]:not([data-cd-init]), [data-countdown-daily]:not([data-cd-init])').forEach(function (el) {
      el.setAttribute('data-cd-init', '');
      var daily = el.hasAttribute('data-countdown-daily');
      var evergreen = parseInt(el.getAttribute('data-countdown-evergreen'), 10);
      var end;
      if (evergreen > 0) {
        var key = 'coro_cd_' + (el.getAttribute('data-cd-key') || 'x');
        var saved = 0;
        try { saved = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
        if (saved <= Date.now()) {
          saved = Date.now() + evergreen * 60000;
          try { localStorage.setItem(key, String(saved)); } catch (e) {}
        }
        end = new Date(saved);
      } else if (daily) {
        end = new Date();
        end.setHours(24, 0, 0, 0);
      } else {
        end = new Date(el.getAttribute('data-countdown').replace(' ', 'T'));
        if (isNaN(end)) return;
      }
      var f = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
      var done = el.querySelector('[data-cd-done]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) {
          if (evergreen > 0) {
            end = new Date(Date.now() + evergreen * 60000);
            try { localStorage.setItem('coro_cd_' + (el.getAttribute('data-cd-key') || 'x'), String(end.getTime())); } catch (e) {}
            ms = end - Date.now();
          } else if (daily) { end = new Date(); end.setHours(24, 0, 0, 0); ms = end - Date.now(); }
          else { el.classList.add('is-done'); if (done) done.hidden = false; clearInterval(iv); return; }
        }
        var s = Math.floor(ms / 1000);
        if (f.d) f.d.textContent = pad(Math.floor(s / 86400));
        if (f.h) f.h.textContent = pad(Math.floor(s % 86400 / 3600));
        if (f.m) f.m.textContent = pad(Math.floor(s % 3600 / 60));
        if (f.s) f.s.textContent = pad(s % 60);
      }
      tick();
      var iv = setInterval(tick, 1000);
    });
  }

  /* Carruseles con flechas */
  function initCarousels(root) {
    root.querySelectorAll('[data-carousel]:not([data-car-init])').forEach(function (wrap) {
      wrap.setAttribute('data-car-init', '');
      var track = wrap.querySelector('[data-carousel-track]');
      if (!track) return;
      /* Arrastre con mouse (el touch nativo ya desliza solo) */
      var down = false, startX = 0, startL = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; startX = e.clientX; startL = track.scrollLeft;
        track.style.cursor = 'grabbing';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        track.scrollLeft = startL - (e.clientX - startX);
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        track.addEventListener(ev, function () { down = false; track.style.cursor = ''; });
      });

      wrap.querySelectorAll('[data-carousel-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.firstElementChild;
          var w = card ? card.getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: btn.getAttribute('data-carousel-btn') === 'next' ? w : -w, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Acordeones (delegado: funciona siempre, incluso tras re-render) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acc]');
    if (!btn) return;
    var item = btn.parentElement;
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
  });

  function initAll(root) {
    initReveal(root);
    initCountdown(root);
    initCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Editor de Shopify: re-inicializar cuando una sección se recarga */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  function initProductSticky(root) {
    root.querySelectorAll('[data-product-sticky]:not([data-sticky-init])').forEach(function (bar) {
      bar.setAttribute('data-sticky-init', '');
      var buy = document.querySelector('[data-main-buy-area]');
      if (!buy || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-soft-hidden', entry.isIntersecting);
        });
      }, { threshold: 0.2 });
      io.observe(buy);
    });
  }

  function initScrollTop(root) {
    root.querySelectorAll('[data-scroll-top]:not([data-scroll-top-init])').forEach(function (btn) {
      btn.setAttribute('data-scroll-top-init', '');
      var threshold = parseInt(btn.getAttribute('data-threshold'), 10) || 360;
      var ticking = false;
      function update() {
        ticking = false;
        btn.classList.toggle('is-visible', window.scrollY > threshold);
      }
      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
  }

  initProductSticky(document);
  initScrollTop(document);
  document.addEventListener('shopify:section:load', function (e) {
    initProductSticky(document);
    initScrollTop(e.target);
  });

  /* ---- Interacciones delegadas (sobreviven a re-renders del editor) ---- */
  document.addEventListener('click', function (e) {
    /* Tabs */
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      var group = tab.closest('[data-tabs]');
      group.querySelectorAll('[data-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on);
      });
      group.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-tab-panel') !== tab.getAttribute('data-tab');
      });
      return;
    }
    /* Copiar código de cupón */
    var copy = e.target.closest('[data-copy]');
    if (copy) {
      var code = copy.getAttribute('data-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        var prev = copy.textContent;
        copy.textContent = '¡Copiado!';
        setTimeout(function () { copy.textContent = prev; }, 1600);
      }).catch(function () { window.prompt('Copiá el código:', code); });
      return;
    }
    /* Galería: miniaturas */
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-gallery]');
      var main = gal.querySelector('[data-gallery-main]');
      if (main) { main.src = thumb.getAttribute('data-thumb'); main.srcset = ''; }
      gal.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      return;
    }
    /* Cantidad +/- */
    var qbtn = e.target.closest('[data-qty]');
    if (qbtn) {
      var input = qbtn.parentElement.querySelector('input[name="quantity"]');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + (qbtn.getAttribute('data-qty') === '+' ? 1 : -1));
      return;
    }
  });

  /* Antes / Después: el range controla la posición del corte */
  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-ba-range]');
    if (!r) return;
    r.closest('[data-ba]').style.setProperty('--pos', r.value + '%');
  });
})();

/* Galería de producto: miniaturas (delegado) */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('[data-thumb]');
  if (!thumb) return;
  var scope = thumb.closest('.shopify-section') || document;
  var main = scope.querySelector('[data-main-img]');
  if (!main) return;
  main.src = thumb.getAttribute('data-src');
  if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset');
  scope.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
  thumb.classList.add('is-active');
});

/* Copiar códigos de cupón (delegado) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-copy]');
  if (!btn) return;
  var code = btn.getAttribute('data-copy');
  function done() {
    var prev = btn.textContent;
    btn.textContent = '¡Copiado!';
    setTimeout(function () { btn.textContent = prev; }, 1600);
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(done).catch(done);
  } else { done(); }
});

/* Antes / Después (delegado por evento input) */
document.addEventListener('input', function (e) {
  var r = e.target.closest('[data-ba-range]');
  if (!r) return;
  r.closest('[data-ba]').style.setProperty('--pos', r.value + '%');
});

/* ===== Página de producto ===== */

/* Galería: cambiar imagen principal al tocar una miniatura */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-thumb]');
  if (!t) return;
  var g = t.closest('[data-gallery]');
  var main = g && g.querySelector('[data-main-img]');
  if (!main) return;
  main.src = t.getAttribute('data-src');
  if (t.getAttribute('data-srcset')) main.srcset = t.getAttribute('data-srcset');
  g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
  t.classList.add('is-active');
});

/* Copiar código de cupón */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-copy]');
  if (!b) return;
  var code = b.getAttribute('data-copy');
  function ok() {
    var prev = b.textContent;
    b.textContent = '✓ Copiado';
    setTimeout(function () { b.textContent = prev; }, 1600);
  }
  function fallback() {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
    ok();
  }
  if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
    navigator.clipboard.writeText(code).then(ok, fallback);
  } else { fallback(); }
});

/* Antes / Después: el range controla la posición del corte */
document.addEventListener('input', function (e) {
  var r = e.target.closest('[data-ba-range]');
  if (!r) return;
  var box = r.closest('[data-ba]');
  if (box) box.style.setProperty('--pos', r.value + '%');
});

/* Selector de variantes: actualiza id, precio y disponibilidad */
document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-variant-select]');
  if (!sel) return;
  var root = sel.closest('[data-product]');
  if (!root) return;
  var dataEl = root.querySelector('[data-variants-json]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
  var opts = [];
  root.querySelectorAll('[data-variant-select]').forEach(function (s) { opts.push(s.value); });
  var match = variants.find(function (v) {
    return v.options.every(function (o, i) { return o === opts[i]; });
  });
  var btns = root.querySelectorAll('[data-buy-btn]');
  if (!match) {
    btns.forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-label-unavailable') || 'No disponible'; });
    return;
  }
  root.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = match.id; });
  root.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = match.price; });
  root.querySelectorAll('[data-compare]').forEach(function (c) {
    if (match.cap_raw > match.price_raw) { c.textContent = match.cap; c.hidden = false; }
    else { c.hidden = true; }
  });
  btns.forEach(function (b) {
    b.disabled = !match.available;
    b.textContent = match.available ? (b.getAttribute('data-label') || b.textContent) : (b.getAttribute('data-label-unavailable') || 'Agotado');
  });
});

/* Cantidad: botones +/- */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-qty-btn]');
  if (!b) return;
  var input = b.parentElement.querySelector('input[name="quantity"]');
  if (!input) return;
  var v = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, v + (b.getAttribute('data-qty-btn') === 'plus' ? 1 : -1));
});

/* Live viewers: cantidad que rota para generar urgencia */
(function () {
  function initViewers(root) {
    root.querySelectorAll('[data-viewers]:not([data-vw-init])').forEach(function (el) {
      el.setAttribute('data-vw-init', '');
      var min = parseInt(el.getAttribute('data-min'), 10) || 12;
      var max = parseInt(el.getAttribute('data-max'), 10) || 30;
      var num = el.querySelector('[data-viewers-num]');
      if (!num) return;
      var current = min + Math.floor(Math.random() * (max - min + 1));
      num.textContent = current;
      setInterval(function () {
        var delta = Math.floor(Math.random() * 5) - 2; /* -2..+2 */
        current = Math.min(max, Math.max(min, current + delta));
        num.textContent = current;
      }, 4000 + Math.random() * 4000);
    });
  }
  initViewers(document);
  document.addEventListener('shopify:section:load', function (e) { initViewers(e.target); });
})();

/* Video: fachada liviana, el iframe se carga recién al tocar play */
document.addEventListener('click', function (e) {
  var v = e.target.closest('[data-video]');
  if (!v || v.classList.contains('is-playing')) return;
  var url = v.getAttribute('data-video');
  var iframe = document.createElement('iframe');
  iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
  iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
  iframe.allowFullscreen = true;
  iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
  v.appendChild(iframe);
  v.classList.add('is-playing');
});

/* Galería móvil: sincronizar dots con el slide visible */
(function () {
  function initGalSliders(root) {
    root.querySelectorAll('[data-gal-slider]:not([data-gs-init])').forEach(function (sl) {
      sl.setAttribute('data-gs-init', '');
      var dots = sl.parentElement.querySelectorAll('[data-gal-dot]');
      if (!dots.length) return;
      function update() {
        var i = Math.round(sl.scrollLeft / sl.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      sl.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () {
          sl.scrollTo({ left: j * sl.clientWidth, behavior: 'smooth' });
        });
      });
      update();
    });
  }
  initGalSliders(document);
  document.addEventListener('shopify:section:load', function (e) { initGalSliders(e.target); });
})();

/* Sliders simples con scroll nativo + puntos */
(function () {
  function initSnapSliders(root) {
    root.querySelectorAll('[data-snap-slider]:not([data-snap-init])').forEach(function (sl) {
      sl.setAttribute('data-snap-init', '');
      var wrap = sl.closest('[data-snap-wrap]') || sl.parentElement;
      var dots = wrap ? wrap.querySelectorAll('[data-snap-dot]') : [];
      /* Paso real = ancho de la primera tarjeta + separacion, no el ancho total del slider.
         Esto evita que el slider salte de mas cuando las tarjetas no ocupan el 100%. */
      function stepWidth() {
        var first = sl.children[0];
        if (!first) return sl.clientWidth || 1;
        var w = first.getBoundingClientRect().width;
        var cs = window.getComputedStyle(sl);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return w + gap || sl.clientWidth || 1;
      }
      function maxIndex() { return Math.max(0, dots.length - 1); }
      function idx() {
        var step = stepWidth();
        if (!step) return 0;
        return Math.max(0, Math.min(maxIndex(), Math.round(sl.scrollLeft / step)));
      }
      function goTo(i) {
        i = Math.max(0, Math.min(maxIndex(), i));
        sl.scrollTo({ left: i * stepWidth(), behavior: 'smooth' });
      }
      function update() {
        var current = idx();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === current); });
      }
      sl.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', function () { requestAnimationFrame(update); }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
      update();
    });
  }
  initSnapSliders(document);
  document.addEventListener('shopify:section:load', function (e) { initSnapSliders(e.target); });
})();

/* Cupón táctil: aplica el descuento de Shopify al tocar el ticket */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-discount]');
  if (!t || t.classList.contains('is-applied')) return;
  var code = t.getAttribute('data-discount');
  var label = t.querySelector('[data-discount-label]');
  fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
    .catch(function () {})
    .finally(function () {
      t.classList.add('is-applied');
      if (label) label.textContent = '✓ Aplicado';
    });
});
document.addEventListener('keydown', function (e) {
  if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-discount')) {
    e.preventDefault();
    e.target.click();
  }
});

/* Resenas del producto: slider classic con autoplay, flechas, dots y arrastre */
(function () {
  function initRevSliders(root) {
    root.querySelectorAll('[data-rev-slider]:not([data-rv-init])').forEach(function (sl) {
      sl.setAttribute('data-rv-init', '');
      var wrap = sl.parentElement;
      var dots = wrap.querySelectorAll('[data-rev-dot]');
      function count() { return sl.children.length; }
      function idx() { return Math.round(sl.scrollLeft / sl.clientWidth); }
      function goTo(i) {
        var n = count();
        i = (i + n) % n;
        sl.scrollTo({ left: i * sl.clientWidth, behavior: 'smooth' });
      }
      function update() {
        var i = idx();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      sl.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j); }); });
      wrap.querySelectorAll('[data-rev-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          goTo(idx() + (b.getAttribute('data-rev-btn') === 'next' ? 1 : -1));
        });
      });
      /* Autoplay con pausa al interactuar */
      var ap = parseFloat(sl.getAttribute('data-autoplay')) || 0;
      if (ap > 0) {
        var timer = setInterval(function () { goTo(idx() + 1); }, ap * 1000);
        ['pointerdown', 'touchstart'].forEach(function (ev) {
          sl.addEventListener(ev, function () { clearInterval(timer); }, { once: true, passive: true });
        });
      }
      update();
    });
  }
  initRevSliders(document);
  document.addEventListener('shopify:section:load', function (e) { initRevSliders(e.target); });
})();

/* Bundle: elegir pack actualiza la cantidad del form */
document.addEventListener('change', function (e) {
  var r = e.target.closest('[data-bundle]');
  if (!r) return;
  var root = r.closest('[data-product]');
  if (root) {
    var qty = root.querySelector('input[name="quantity"]');
    if (qty) qty.value = r.value;
  }
  var fieldset = r.closest('.prod__bundle');
  if (fieldset) {
    fieldset.querySelectorAll('.prod__tier').forEach(function (t) { t.classList.remove('is-active'); });
    var tier = r.closest('.prod__tier');
    if (tier) tier.classList.add('is-active');
  }
});

/* Upsell: agregar al carrito sin salir de la pagina */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-upsell-add]');
  if (!b || b.disabled) return;
  b.disabled = true;
  var original = b.textContent;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(b.getAttribute('data-upsell-add'), 10), quantity: 1 })
  }).then(function (r) {
    if (!r.ok) throw new Error('add failed');
    b.textContent = 'Agregado';
    b.classList.add('is-added');
    var count = document.querySelector('.hdr__count');
    if (count) count.textContent = parseInt(count.textContent || '0', 10) + 1;
  }).catch(function () {
    b.textContent = original;
    b.disabled = false;
  });
});

/* Popup de oferta: delay, scroll o exit-intent, con frecuencia por sesion */
(function () {
  function initPopups(root) {
    try {
      initPopupsInner(root);
    } catch (e) { /* cualquier fallo aca nunca debe frenar el resto del JS de la pagina */ }
  }
  function initPopupsInner(root) {
    root.querySelectorAll('[data-popup]:not([data-pop-init])').forEach(function (pop) {
      pop.setAttribute('data-pop-init', '');
      var trigger = pop.getAttribute('data-trigger');
      var freq = pop.getAttribute('data-frequency');
      var key = 'coro-popup-' + pop.id;

      function alreadyShown() {
        if (freq !== 'session') return false;
        try { return sessionStorage.getItem(key) === '1'; }
        catch (e) { return false; } /* storage bloqueado (iframe del editor, modo privado, etc.) -> nunca rompe la pagina */
      }
      function markShown() {
        if (freq !== 'session') return;
        try { sessionStorage.setItem(key, '1'); } catch (e) { /* si falla, simplemente no recuerda: no rompe nada */ }
      }
      function startMinuteCountdowns() {
        pop.querySelectorAll('[data-countdown-minutes]:not([data-cdm-init])').forEach(function (el) {
          el.setAttribute('data-cdm-init', '');
          var mins = parseFloat(el.getAttribute('data-countdown-minutes')) || 15;
          var end = Date.now() + mins * 60000;
          var f = { h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
          function pad(n) { return String(n).padStart(2, '0'); }
          function tick() {
            var ms = end - Date.now();
            if (ms <= 0) { if (f.h) f.h.textContent = '00'; if (f.m) f.m.textContent = '00'; if (f.s) f.s.textContent = '00'; clearInterval(iv); return; }
            var s = Math.floor(ms / 1000);
            if (f.h) f.h.textContent = pad(Math.floor(s / 3600));
            if (f.m) f.m.textContent = pad(Math.floor(s % 3600 / 60));
            if (f.s) f.s.textContent = pad(s % 60);
          }
          tick();
          var iv = setInterval(tick, 1000);
        });
      }
      function open() {
        if (alreadyShown() || !pop.hidden) return;
        pop.hidden = false;
        markShown();
        document.body.style.overflow = 'hidden';
        startMinuteCountdowns();
      }
      function close() {
        pop.hidden = true;
        document.body.style.overflow = '';
      }
      pop.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      if (alreadyShown()) return;

      if (trigger === 'delay') {
        var sec = parseFloat(pop.getAttribute('data-delay')) || 8;
        setTimeout(open, sec * 1000);
      } else if (trigger === 'scroll') {
        var pct = parseFloat(pop.getAttribute('data-scroll')) || 50;
        var fired = false;
        window.addEventListener('scroll', function () {
          if (fired) return;
          var h = document.documentElement;
          var scrolled = (h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100;
          if (scrolled >= pct) { fired = true; open(); }
        }, { passive: true });
      } else if (trigger === 'exit') {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY < 10) open();
        });
      }
    });
  }
  initPopups(document);
  document.addEventListener('shopify:section:load', function (e) { initPopups(e.target); });
})();

/* Rasca y gana: canvas raspable que revela el premio */
(function () {
  function initScratchCards(root) {
    root.querySelectorAll('[data-scratch]:not([data-scr-init])').forEach(function (box) {
      box.setAttribute('data-scr-init', '');
      var canvas = box.querySelector('[data-scratch-canvas]');
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext('2d');
      var w = canvas.width, h = canvas.height;
      var color = canvas.getAttribute('data-color') || '#c9a227';

      function shadeColor(hex, factor) {
        /* Oscurece el color elegido por el usuario (no un tono fijo) para el degrade del rasca y gana */
        try {
          var h = String(hex).replace('#', '');
          if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
          if (h.length !== 6) return hex;
          var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
          r = Math.max(0, Math.min(255, Math.round(r * factor)));
          g = Math.max(0, Math.min(255, Math.round(g * factor)));
          b = Math.max(0, Math.min(255, Math.round(b * factor)));
          return 'rgb(' + r + ',' + g + ',' + b + ')';
        } catch (e) { return hex; }
      }
      function paintCover() {
        ctx.globalCompositeOperation = 'source-over';
        var grad = ctx.createLinearGradient(0, 0, w, h);
        grad.addColorStop(0, color);
        grad.addColorStop(1, shadeColor(color, 0.6));
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, w, h);
        ctx.strokeStyle = 'rgba(255,255,255,0.18)';
        ctx.lineWidth = 2;
        for (var i = -h; i < w; i += 14) {
          ctx.beginPath();
          ctx.moveTo(i, 0);
          ctx.lineTo(i + h, h);
          ctx.stroke();
        }
      }
      paintCover();

      var scratching = false, lastCheck = 0, revealed = false;

      function toCanvasPos(e) {
        var rect = canvas.getBoundingClientRect();
        var cx = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
        var cy = (e.touches && e.touches[0]) ? e.touches[0].clientY : e.clientY;
        return { x: (cx - rect.left) * (w / rect.width), y: (cy - rect.top) * (h / rect.height) };
      }
      function scratchAt(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, Math.max(w, h) * 0.13, 0, Math.PI * 2);
        ctx.fill();
      }
      function checkPercent() {
        if (revealed) return;
        var data;
        try { data = ctx.getImageData(0, 0, w, h).data; } catch (e) { return; }
        var transparent = 0, sampled = 0;
        for (var i = 3; i < data.length; i += 4 * 6) { sampled++; if (data[i] === 0) transparent++; }
        if (sampled && (transparent / sampled) * 100 > 42) reveal();
      }
      function reveal() {
        if (revealed) return;
        revealed = true;
        box.classList.add('is-revealed');
        var body = box.closest('.popup__body');
        var cta = body ? body.querySelector('[data-scratch-cta]') : null;
        if (cta) cta.hidden = false;
      }

      function onMove(e) {
        if (!scratching) return;
        if (e.cancelable) e.preventDefault();
        var p = toCanvasPos(e);
        scratchAt(p.x, p.y);
        var now = Date.now();
        if (now - lastCheck > 140) { lastCheck = now; checkPercent(); }
      }
      canvas.addEventListener('pointerdown', function (e) { scratching = true; onMove(e); });
      canvas.addEventListener('pointermove', onMove);
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        canvas.addEventListener(ev, function () { scratching = false; });
      });
      canvas.addEventListener('touchstart', function (e) { scratching = true; onMove(e); }, { passive: false });
      canvas.addEventListener('touchmove', onMove, { passive: false });
      canvas.addEventListener('touchend', function () { scratching = false; });
    });
  }
  initScratchCards(document);
  document.addEventListener('shopify:section:load', function (e) { initScratchCards(e.target); });
})();

/* Colección con pestañas: cambiar de panel */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-tab-btn]');
  if (!btn) return;
  var section = btn.closest('[data-tabs]');
  if (!section) return;
  var idx = btn.getAttribute('data-tab-btn');
  section.querySelectorAll('[data-tab-btn]').forEach(function (b) {
    var active = b === btn;
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  section.querySelectorAll('[data-tab-panel]').forEach(function (p) {
    p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === idx);
  });
});

/* Slider de banners: flechas, puntos y autoplay opcional */
(function () {
  function initSliderBanner(root) {
    root.querySelectorAll('.slb:not([data-slb-init])').forEach(function (section) {
      section.setAttribute('data-slb-init', '');
      var slides = section.querySelectorAll('[data-slb-slide]');
      var dots = section.querySelectorAll('[data-slb-dot]');
      if (slides.length < 2) return;
      var current = 0;
      var track = section.querySelector('[data-slb-track]');
      var adapt = section.hasAttribute('data-slb-adapt');
      function goTo(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === current); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === current); });
        if (adapt && track) {
          var r = slides[current].getAttribute('data-ratio');
          if (r) track.style.setProperty('--slb-ratio', r);
        }
      }
      section.querySelectorAll('[data-slb-btn]').forEach(function (b) {
        b.addEventListener('click', function () { goTo(current + (b.getAttribute('data-slb-btn') === 'next' ? 1 : -1)); });
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-slb-dot'), 10)); });
      });
      var auto = parseFloat(section.getAttribute('data-autoplay')) || 0;
      if (auto > 0) {
        var timer = setInterval(function () { goTo(current + 1); }, auto * 1000);
        section.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
      }

      /* Deslizar (swipe) con mouse, touch o lapiz para cambiar de slide */
      if (track) {
        var dragging = false, deciding = false, sx = 0, sy = 0, pid = null;
        track.style.touchAction = 'pan-y';
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          deciding = true; dragging = false;
          sx = e.clientX; sy = e.clientY; pid = e.pointerId;
        });
        track.addEventListener('pointermove', function (e) {
          if (!deciding || e.pointerId !== pid) return;
          var dx = e.clientX - sx, dy = e.clientY - sy;
          if (!dragging) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            if (Math.abs(dx) <= Math.abs(dy)) { deciding = false; return; }
            dragging = true;
            try { track.setPointerCapture(pid); } catch (err) {}
          }
          e.preventDefault();
        });
        function swipeEnd(e) {
          if (dragging && e.pointerId === pid) {
            var dx = e.clientX - sx;
            if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
          }
          deciding = false; dragging = false;
        }
        track.addEventListener('pointerup', swipeEnd);
        track.addEventListener('pointercancel', function () { deciding = false; dragging = false; });
      }
    });
  }
  initSliderBanner(document);
  document.addEventListener('shopify:section:load', function (e) { initSliderBanner(e.target); });
})();

/* Video slider Pro: flechas + click para reproducir */
(function () {
  function initVideoSliderPro(root) {
    root.querySelectorAll('.vslp__wrap:not([data-vslp-init])').forEach(function (wrap) {
      wrap.setAttribute('data-vslp-init', '');
      var track = wrap.querySelector('[data-vslp-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-vslp-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector('.vslp__slide');
          var w = card ? card.getBoundingClientRect().width + 19.2 : 300;
          track.scrollBy({ left: b.getAttribute('data-vslp-btn') === 'next' ? w : -w, behavior: 'smooth' });
        });
      });
      track.querySelectorAll('[data-video]').forEach(function (box) {
        var url = box.getAttribute('data-video');
        if (!url) return;
        box.addEventListener('click', function () {
          if (box.classList.contains('is-playing')) return;
          var iframe = document.createElement('iframe');
          iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
          box.appendChild(iframe);
          box.classList.add('is-playing');
        });
      });
      track.querySelectorAll('[data-vslp-native-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var video = btn.previousElementSibling;
          if (video && video.tagName === 'VIDEO') {
            video.controls = true;
            video.play();
            btn.style.display = 'none';
          }
        });
      });
    });
  }
  initVideoSliderPro(document);
  document.addEventListener('shopify:section:load', function (e) { initVideoSliderPro(e.target); });
})();

/* Arrastrar para deslizar (funciona con mouse, touch o lapiz, sin depender del navegador) */
(function () {
  function initDragScroll(root) {
    root.querySelectorAll('[data-drag-scroll], [data-snap-slider], [data-gal-slider], [data-rev-slider]').forEach(function (track) {
      if (track.hasAttribute('data-drag-init')) return;
      track.setAttribute('data-drag-init', '');
      var dragging = false, deciding = false, startX = 0, startY = 0, startScroll = 0, pid = null;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        deciding = true; dragging = false;
        startX = e.clientX; startY = e.clientY;
        startScroll = track.scrollLeft;
        pid = e.pointerId;
      });

      track.addEventListener('pointermove', function (e) {
        if (!deciding || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!dragging) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dx) <= Math.abs(dy)) { deciding = false; return; }
          dragging = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(pid); } catch (err) {}
        }
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      });

      function stop(e) {
        deciding = false;
        if (dragging) {
          dragging = false;
          track.classList.remove('is-dragging');
          var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); track.removeEventListener('click', swallow, true); };
          track.addEventListener('click', swallow, true);
        }
      }
      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);
      track.addEventListener('pointerleave', stop);
    });
  }
  initDragScroll(document);
  document.addEventListener('shopify:section:load', function (e) { initDragScroll(e.target); });
})();

/* Galeria de videos del producto: autoplay silencioso tras cargar la pagina + control de sonido, o play manual */
(function () {
  var pageLoaded = document.readyState === 'complete';
  var pending = [];

  function flush() {
    pageLoaded = true;
    pending.forEach(function (item) { attemptPlay(item); });
    pending = [];
  }
  if (!pageLoaded) window.addEventListener('load', flush);

  function attemptPlay(item) {
    if (!pageLoaded) { pending.push(item); return; }
    var p = item.video.play();
    if (p && p.catch) {
      p.catch(function () {
        item.box.classList.remove('is-playing');
        if (item.playBtn) item.playBtn.hidden = false;
      });
    }
  }

  function initVgalleryAutoplay(root) {
    root.querySelectorAll('[data-vgallery-native]:not([data-vgn-init])').forEach(function (box) {
      box.setAttribute('data-vgn-init', '');
      var video = box.querySelector('video');
      var playBtn = box.querySelector('[data-vgallery-native-play]');
      var muteBtn = box.querySelector('[data-vgallery-mute]');
      var autoplay = box.getAttribute('data-autoplay') !== 'false';
      if (!video) return;

      if (autoplay) {
        if (playBtn) playBtn.hidden = true;
        if (muteBtn) muteBtn.hidden = false;
        var item = { video: video, box: box, playBtn: playBtn };

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                box.classList.add('is-playing');
                attemptPlay(item);
              } else {
                video.pause();
              }
            });
          }, { threshold: 0.4 });
          io.observe(box);
        } else {
          box.classList.add('is-playing');
          attemptPlay(item);
        }

        if (muteBtn) {
          muteBtn.addEventListener('click', function () {
            video.muted = !video.muted;
            muteBtn.classList.toggle('is-unmuted', !video.muted);
            muteBtn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
          });
        }
      } else if (playBtn) {
        playBtn.addEventListener('click', function () {
          video.muted = false;
          video.controls = true;
          video.play();
          box.classList.add('is-playing');
          playBtn.hidden = true;
        });
      }
    });
  }
  initVgalleryAutoplay(document);
  document.addEventListener('shopify:section:load', function (e) { initVgalleryAutoplay(e.target); });
})();

/* Glow Testimonial: pausar/reanudar el marquee de dos filas */
(function () {
  function initTglow(root) {
    root.querySelectorAll('[data-tglow]:not([data-tglow-init])').forEach(function (section) {
      section.setAttribute('data-tglow-init', '');
      var btn = section.querySelector('[data-tglow-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        section.classList.toggle('is-paused');
        btn.classList.toggle('is-paused');
      });
    });
  }
  initTglow(document);
  document.addEventListener('shopify:section:load', function (e) { initTglow(e.target); });
})();

/* Coleccion spotlight: pestañas + slide central destacado + info sincronizada */
(function () {
  function initSpotlight(root) {
    root.querySelectorAll('[data-fcsp]:not([data-fcsp-init])').forEach(function (section) {
      section.setAttribute('data-fcsp-init', '');
      var tabs = section.querySelectorAll('[data-fcsp-tab]');
      var panels = section.querySelectorAll('[data-fcsp-panel]');

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = t.getAttribute('data-fcsp-tab');
          tabs.forEach(function (x) {
            var on = x === t;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-fcsp-panel') === idx;
            p.classList.toggle('is-active', on);
            if (on) {
              var bg = p.getAttribute('data-bg');
              if (bg) section.style.setProperty('--fcsp-bg', bg);
              var tr = p.querySelector('[data-fcsp-track]');
              if (tr && tr.__fcspCenter) tr.__fcspCenter(true);
            }
          });
        });
      });

      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-fcsp-track]');
        if (!track) return;
        var slides = track.querySelectorAll('.fcsp__slide');
        var body = panel.querySelector('.fcsp__info-body');
        var titleEl = panel.querySelector('[data-fcsp-title]');
        var descEl = panel.querySelector('[data-fcsp-desc]');
        var linkEl = panel.querySelector('[data-fcsp-link]');
        if (!slides.length) return;
        var current = -1;

        function centerOf(el) { return el.offsetLeft + el.offsetWidth / 2; }

        function setInfo(slide) {
          if (titleEl) titleEl.textContent = slide.getAttribute('data-title') || '';
          if (descEl) descEl.textContent = slide.getAttribute('data-desc') || '';
          if (linkEl) linkEl.setAttribute('href', slide.getAttribute('data-url') || '#');
        }

        function update(instant) {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (s, j) {
            var d = Math.abs(centerOf(s) - mid);
            if (d < bestDist) { bestDist = d; best = j; }
          });
          if (best === current) return;
          current = best;
          slides.forEach(function (s, j) { s.classList.toggle('is-center', j === best); });
          var shapeColor = slides[best].getAttribute('data-shape');
          if (shapeColor) section.style.setProperty('--fcsp-shape', shapeColor);
          if (instant || !body) { setInfo(slides[best]); return; }
          body.classList.add('is-fading');
          setTimeout(function () { setInfo(slides[best]); body.classList.remove('is-fading'); }, 220);
        }

        function goTo(idx) {
          idx = Math.max(0, Math.min(slides.length - 1, idx));
          var target = centerOf(slides[idx]) - track.clientWidth / 2;
          track.scrollTo({ left: target, behavior: 'smooth' });
        }

        panel.querySelectorAll('[data-fcsp-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            goTo(current + (b.getAttribute('data-fcsp-btn') === 'next' ? 1 : -1));
          });
        });

        var ticking = false;
        track.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(false); }); }
        }, { passive: true });

        function centerInitial(force) {
          var start = Math.min(slides.length - 1, Math.floor(slides.length / 2));
          track.scrollLeft = centerOf(slides[start]) - track.clientWidth / 2;
          current = -1;
          update(true);
        }
        track.__fcspCenter = centerInitial;
        centerInitial();
        setTimeout(centerInitial, 120);

        var resizeTicking = false;
        window.addEventListener('resize', function () {
          if (resizeTicking) return;
          resizeTicking = true;
          requestAnimationFrame(function () {
            resizeTicking = false;
            var idx = Math.max(0, current);
            track.scrollLeft = centerOf(slides[idx]) - track.clientWidth / 2;
          });
        });
      });
    });
  }
  initSpotlight(document);
  document.addEventListener('shopify:section:load', function (e) { initSpotlight(e.target); });
})();

/* Galeria de videos del producto: dots sincronizados con el deslizamiento (movil) */
(function () {
  function initVgalleryDots(root) {
    root.querySelectorAll('[data-vgallery-track]:not([data-vgd-init])').forEach(function (track) {
      track.setAttribute('data-vgd-init', '');
      var dotsWrap = track.parentElement.querySelector('[data-vgallery-dots]');
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('span');
      var items = track.querySelectorAll('.prod__vgallery-item');
      if (!dots.length || !items.length) return;
      var ticking = false;
      function update() {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        var idx = max > 0 ? Math.round(track.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      }
      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
    });
  }
  initVgalleryDots(document);
  document.addEventListener('shopify:section:load', function (e) { initVgalleryDots(e.target); });
})();

/* Paso a paso con scroll: la imagen fija cambia segun que paso este mas a la vista */
(function () {
  function initScrollSteps(root) {
    root.querySelectorAll('[data-scrollsteps]:not([data-scrollsteps-init])').forEach(function (section) {
      section.setAttribute('data-scrollsteps-init', '');
      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-scrollstep]'));
      var medias = section.querySelectorAll('[data-scrollstep-media]');
      var nums = steps.map(function (s) { return s.querySelector('.itxs__num'); });
      var fills = steps.map(function (s) { return s.querySelector('.itxs__line-fill'); });
      if (!steps.length) return;

      var ticking = false;

      function update() {
        ticking = false;
        var triggerY = window.innerHeight * 0.5;
        var centers = nums.map(function (n) {
          var r = n.getBoundingClientRect();
          return r.top + r.height / 2;
        });

        var activeIdx = 0;
        for (var i = 0; i < centers.length; i++) {
          if (centers[i] <= triggerY) activeIdx = i;
        }

        steps.forEach(function (s, i) {
          s.classList.toggle('is-active', i === activeIdx);
          s.classList.toggle('is-done', i < activeIdx);
        });
        medias.forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-scrollstep-media') === String(activeIdx));
        });

        fills.forEach(function (fill, i) {
          if (!fill) return;
          var cur = centers[i];
          var next = centers[i + 1];
          var progress;
          if (next === undefined) {
            progress = triggerY >= cur ? 1 : 0;
          } else if (next === cur) {
            progress = triggerY >= cur ? 1 : 0;
          } else {
            progress = (triggerY - cur) / (next - cur);
          }
          progress = Math.max(0, Math.min(1, progress));
          fill.style.transform = 'scaleY(' + progress + ')';
        });
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }
  initScrollSteps(document);
  document.addEventListener('shopify:section:load', function (e) { initScrollSteps(e.target); });
})();

/* Features con pestanas: cambio de panel (fade) + flechas */
(function () {
  function initFeatureTabs(root) {
    root.querySelectorAll('[data-ftabs]:not([data-ftabs-init])').forEach(function (section) {
      section.setAttribute('data-ftabs-init', '');
      var tabs = section.querySelectorAll('[data-ftabs-tab]');
      var panels = section.querySelectorAll('[data-ftabs-panel]');
      if (!tabs.length) return;

      function goTo(idx) {
        idx = (idx + tabs.length) % tabs.length;
        tabs.forEach(function (t, j) {
          var on = j === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', j === idx); });
        var activeTab = section.querySelector('[data-ftabs-tab].is-active');
        if (activeTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      tabs.forEach(function (t, j) { t.addEventListener('click', function () { goTo(j); }); });
      section.querySelectorAll('[data-ftabs-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var current = section.querySelector('[data-ftabs-tab].is-active');
          var idx = current ? Array.prototype.indexOf.call(tabs, current) : 0;
          goTo(idx + (b.getAttribute('data-ftabs-btn') === 'next' ? 1 : -1));
        });
      });
    });
  }
  initFeatureTabs(document);
  document.addEventListener('shopify:section:load', function (e) { initFeatureTabs(e.target); });
})();

/* Slider 3D (coverflow): rota y escala los slides segun su distancia al centro */
(function () {
  function initCoverflow(root) {
    root.querySelectorAll('[data-cvf]:not([data-cvf-init])').forEach(function (section) {
      section.setAttribute('data-cvf-init', '');
      var track = section.querySelector('[data-cvf-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.cvf__slide');
      var cards = track.querySelectorAll('.cvf__card');
      var maxAngle = parseFloat(section.getAttribute('data-cvf-angle')) || 25;
      var ticking = false;

      function update() {
        ticking = false;
        var mid = track.scrollLeft + track.clientWidth / 2;
        slides.forEach(function (s, j) {
          var center = s.offsetLeft + s.offsetWidth / 2;
          var dist = (center - mid) / (track.clientWidth / 2);
          dist = Math.max(-1.4, Math.min(1.4, dist));
          var angle = dist * maxAngle;
          var scale = 1 - Math.min(Math.abs(dist), 1) * 0.14;
          var card = cards[j];
          if (card) {
            card.style.transform = 'rotateY(' + (-angle) + 'deg) scale(' + scale + ')';
            card.style.zIndex = String(100 - Math.round(Math.abs(dist) * 10));
          }
        });
      }

      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      });

      section.querySelectorAll('[data-cvf-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-cvf-btn') === 'next' ? 1 : -1;
          var mid = track.scrollLeft + track.clientWidth / 2;
          var idx = 0, best = Infinity;
          slides.forEach(function (s, j) {
            var center = s.offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(center - mid);
            if (d < best) { best = d; idx = j; }
          });
          var target = slides[Math.max(0, Math.min(slides.length - 1, idx + dir))];
          if (target) {
            track.scrollTo({ left: target.offsetLeft + target.offsetWidth / 2 - track.clientWidth / 2, behavior: 'smooth' });
          }
        });
      });

      update();
      setTimeout(update, 120);
    });
  }
  initCoverflow(document);
  document.addEventListener('shopify:section:load', function (e) { initCoverflow(e.target); });
})();

/* Anatomia del producto: dibuja las lineas SVG entre cada punto y su feature, y anima al entrar en pantalla */
(function () {
  function initAnatomy(root) {
    root.querySelectorAll('[data-anat]:not([data-anat-init])').forEach(function (section) {
      section.setAttribute('data-anat-init', '');
      var layout = section.querySelector('[data-anat-layout]');
      var svg = section.querySelector('[data-anat-svg]');
      if (!layout || !svg) return;
      var dots = section.querySelectorAll('[data-anat-dot]');
      var features = section.querySelectorAll('[data-anat-feature]');
      var played = false;

      function build() {
        if (window.innerWidth < 900) return;
        var lr = layout.getBoundingClientRect();
        svg.setAttribute('viewBox', '0 0 ' + lr.width + ' ' + lr.height);
        svg.innerHTML = '';
        dots.forEach(function (dot) {
          var idx = dot.getAttribute('data-anat-dot');
          var feature = section.querySelector('[data-anat-feature="' + idx + '"]');
          if (!feature) return;
          var dr = dot.getBoundingClientRect();
          var fr = feature.getBoundingClientRect();
          var dx = dr.left + dr.width / 2 - lr.left;
          var dy = dr.top + dr.height / 2 - lr.top;
          var isLeft = fr.left + fr.width / 2 < dr.left + dr.width / 2;
          var fx = (isLeft ? fr.right : fr.left) - lr.left;
          var fy = fr.top + fr.height / 2 - lr.top;
          var midX = (dx + fx) / 2;
          var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M ' + dx + ',' + dy + ' C ' + midX + ',' + dy + ' ' + midX + ',' + fy + ' ' + fx + ',' + fy);
          svg.appendChild(path);
          var len = path.getTotalLength();
          path.style.strokeDasharray = String(len);
          path.style.strokeDashoffset = String(len);
          path.style.transition = 'stroke-dashoffset 900ms ease-out';
          if (played) requestAnimationFrame(function () { path.style.strokeDashoffset = '0'; });
        });
      }

      function play() {
        if (played) return;
        played = true;
        svg.querySelectorAll('path').forEach(function (p) {
          requestAnimationFrame(function () { p.style.strokeDashoffset = '0'; });
        });
        features.forEach(function (f, i) {
          setTimeout(function () { f.classList.add('is-in'); }, i * 90);
        });
      }

      build();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { build(); play(); io.disconnect(); }
          });
        }, { threshold: 0.35 });
        io.observe(section);
      } else {
        play();
      }

      var resizeTicking = false;
      window.addEventListener('resize', function () {
        if (resizeTicking) return;
        resizeTicking = true;
        requestAnimationFrame(function () { resizeTicking = false; build(); });
      });
    });
  }
  initAnatomy(document);
  document.addEventListener('shopify:section:load', function (e) { initAnatomy(e.target); });
})();

/* Header premium: transparencia inteligente.
   - Si la primera seccion (hero) no tiene imagen/video de fondo -> solido siempre.
   - Si tiene -> transparente sobre el hero y solido al scrollear mas alla.
   - is-fixed: pasa de absolute (debajo de la barra de anuncio) a fixed solo al scrollear. */
(function () {
  function initHeaderPremium(root) {
    root.querySelectorAll('[data-hp].hp--transparent:not([data-hp-init])').forEach(function (hdr) {
      hdr.setAttribute('data-hp-init', '');
      var wrapper = hdr.closest('[id^="shopify-section-"]') || hdr.parentElement;
      var solidify = hdr.classList.contains('hp--solidify');
      var sticky = hdr.classList.contains('hp--sticky');
      var heroBottom = 0;
      var heroHasMedia = false;
      var wrapperTop = 0;

      function bgIsDark(el) {
        var bg = getComputedStyle(el).backgroundColor;
        var m = bg.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\s*\)/);
        if (!m) return null;
        var a = m[4] === undefined ? 1 : parseFloat(m[4]);
        if (a < 0.4) return null;
        var lum = (0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3]) / 255;
        return lum < 0.62;
      }

      function measure() {
        var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
        var hero = main.querySelector('.shopify-section') || main.firstElementChild;
        heroHasMedia = false;
        heroBottom = 0;
        if (hero) {
          var rect = hero.getBoundingClientRect();
          heroBottom = rect.top + window.scrollY + hero.offsetHeight;
          var medias = hero.querySelectorAll('img, video');
          for (var i = 0; i < medias.length; i++) {
            var mr = medias[i].getBoundingClientRect();
            if (mr.width > window.innerWidth * 0.5 && mr.height > 200) { heroHasMedia = true; break; }
          }
          if (!heroHasMedia) {
            var bgEls = hero.querySelectorAll('[style*="background-image"]');
            for (var j = 0; j < bgEls.length; j++) {
              var br = bgEls[j].getBoundingClientRect();
              if (br.width > window.innerWidth * 0.5 && br.height > 200) { heroHasMedia = true; break; }
            }
          }
          if (!heroHasMedia) {
            var paintEls = [hero];
            var kids = hero.querySelectorAll('*');
            for (var k = 0; k < kids.length && k < 80; k++) paintEls.push(kids[k]);
            for (var p = 0; p < paintEls.length; p++) {
              var el = paintEls[p];
              if (el.offsetWidth > window.innerWidth * 0.8 && el.offsetHeight > 180 && bgIsDark(el) === true) {
                heroHasMedia = true;
                break;
              }
            }
          }
        }
        wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
      }

      function update() {
        var y = window.scrollY;
        var fixed = sticky && y > wrapperTop;
        hdr.classList.toggle('is-fixed', fixed);
        var solid = !heroHasMedia
          || (y + hdr.offsetHeight > heroBottom)
          || (solidify && y > 40);
        hdr.classList.toggle('is-solid', solid);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }

      measure();
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); });
      window.addEventListener('load', function () { measure(); update(); });
      document.addEventListener('shopify:section:load', function () { measure(); update(); });
      setTimeout(function () { measure(); update(); }, 600);
      setTimeout(function () { measure(); update(); }, 1800);
    });
  }
  initHeaderPremium(document);
  document.addEventListener('shopify:section:load', function (e) { initHeaderPremium(e.target); });
})();

/* Drawer de navegacion (ambos headers): cerrar al tocar el fondo, la X, o un link */
(function () {
  function initDrawerClose(root) {
    root.querySelectorAll('[data-nav-drawer]:not([data-drawer-init])').forEach(function (details) {
      details.setAttribute('data-drawer-init', '');
      function close() { details.removeAttribute('open'); }
      var scrim = details.querySelector('[data-drawer-scrim]');
      var closeBtn = details.querySelector('[data-drawer-close]');
      if (scrim) scrim.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', close);
      details.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && details.hasAttribute('open')) close();
      });
    });
  }
  initDrawerClose(document);
  document.addEventListener('shopify:section:load', function (e) { initDrawerClose(e.target); });
})();

/* Tracking del click de WhatsApp: dispara Contact para Meta Pixel (si existe) y deja rastro en dataLayer */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (!a) return;
    try {
      if (typeof fbq === 'function') fbq('track', 'Contact', { content_category: 'whatsapp' });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'whatsapp_click', link_url: a.href });
    } catch (err) { /* nunca bloquear la navegacion */ }
  }, { capture: true, passive: true });
})();

/* Sales pop: notificacion de compras recientes */
(function () {
  function initSalesPop(root) {
    root.querySelectorAll('[data-spop]:not([data-spop-init])').forEach(function (pop) {
      pop.setAttribute('data-spop-init', '');
      var section = pop.closest('[id^="shopify-section-"]') || document;
      var dataEl = section.querySelector('[data-spop-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data.products.length || !data.names.length) return;
      var img = pop.querySelector('[data-spop-img]');
      var elName = pop.querySelector('[data-spop-name]');
      var elCity = pop.querySelector('[data-spop-city]');
      var elProd = pop.querySelector('[data-spop-product]');
      var elMin = pop.querySelector('[data-spop-min]');
      var interval = (parseInt(pop.getAttribute('data-interval'), 10) || 30) * 1000;
      var duration = (parseInt(pop.getAttribute('data-duration'), 10) || 6) * 1000;
      var firstDelay = (parseInt(pop.getAttribute('data-first-delay'), 10) || 8) * 1000;
      var closed = false;
      pop.hidden = false;

      function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

      function show() {
        if (closed) return;
        var p = pick(data.products);
        elName.textContent = pick(data.names);
        elCity.textContent = pick(data.cities) || '';
        elProd.textContent = p.title;
        elMin.textContent = String(2 + Math.floor(Math.random() * 38));
        if (p.image) { img.src = p.image; img.hidden = false; } else { img.hidden = true; }
        pop.classList.add('is-visible');
        setTimeout(function () { pop.classList.remove('is-visible'); }, duration);
      }

      pop.querySelector('[data-spop-close]').addEventListener('click', function () {
        closed = true;
        pop.classList.remove('is-visible');
      });

      setTimeout(function () {
        show();
        setInterval(show, interval);
      }, firstDelay);
    });
  }
  initSalesPop(document);
  document.addEventListener('shopify:section:load', function (e) { initSalesPop(e.target); });
})();

/* Guia de talles: abrir/cerrar el modal */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sg-open]');
    if (open) {
      var modal = document.querySelector('[data-sg-modal="' + open.getAttribute('data-sg-open') + '"]');
      if (modal) modal.hidden = false;
      return;
    }
    var close = e.target.closest('[data-sg-close]');
    if (close) {
      var m = close.closest('[data-sg-modal]');
      if (m) m.hidden = true;
    }
  });
})();

/* Upsell pre-checkout: intercepta el submit del form de producto una sola vez */
(function () {
  var passed = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'CoroProductForm' || passed) return;
    var root = form.closest('[data-product]') || document;
    var modal = root.querySelector('[data-um]');
    if (!modal) return;
    e.preventDefault();
    modal.hidden = false;

    function proceed() {
      passed = true;
      modal.hidden = true;
      form.submit();
    }

    modal.querySelectorAll('[data-um-skip]').forEach(function (b) {
      b.addEventListener('click', proceed, { once: true });
    });
    var addBtn = modal.querySelector('[data-um-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(modal.getAttribute('data-um-variant'), 10), quantity: 1 })
        }).then(proceed).catch(proceed);
      }, { once: true });
    }
  });
})();

/* Donde esta mi pedido: prellenar el numero en el link de WhatsApp */
(function () {
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-ostat-order]');
    if (!input) return;
    var wrap = input.closest('[data-ostat]');
    var a = wrap && wrap.querySelector('[data-ostat-wa]');
    if (!a) return;
    var msg = a.getAttribute('data-msg') || '';
    if (input.value.trim()) msg += ', mi numero de pedido es: ' + input.value.trim();
    a.href = a.getAttribute('data-base') + '?text=' + encodeURIComponent(msg);
  });
})();
